import APIService from "@/services/APIService.js"; 

export default {
    getBancosPrecosCalculos(includeExpiredRecords) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/getBancosPrecosCalculos/${includeExpiredRecords}`);
    },
    getBancosPrecosCalculosByStatus(status) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/getBancosPrecosCalculos/${status}`);
    },
    getBancoPrecosCalculos(id) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/getBancoPrecosCalculos/${id}`);
    },
    salvar(postData, id) {
        return APIService.apiCall().post(`/bancoPrecoCalculos/salvar/${id}`,JSON.stringify(postData))
    },
    executar(id) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/executar/${id}`);
    },
    duplicar(id) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/duplicar/${id}`);
      },
    excluir(id) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/excluir/${id}`);
    },
    download(id, config = {}) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/baixarPlanilha/${id}`, { responseType: "blob", ...config });
    },
    andamento(id) {
        return APIService.apiCall().get(`/bancoPrecoCalculos/andamento/${id}`);
    }
};